import React from "react";
import CardSection from "../../../components/ui/CardSection";
import ChoiceRow from "../../../components/ui/ChoiceRow";
import { IAddress } from "../../../classes/interfaces";

interface DeliveryAddressFormProps {
  localAddress?: IAddress;
  onOpenAddressModal: () => void;
}

export default function DeliveryAddressForm({ localAddress, onOpenAddressModal }: DeliveryAddressFormProps) {
  return (
    <CardSection icon="pin" title="Local da Entrega">
      <ChoiceRow
        icon="pin"
        title="Endereço"
        sub={
          localAddress !== undefined
            ? localAddress.address + ", " + localAddress.number + " - " + localAddress.district
            : "Escolha o endereço de entrega"
        }
        selected={localAddress !== undefined}
        onClick={onOpenAddressModal}
        last
      />
    </CardSection>
  );
}
